"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;
exports.getPrev = exports.getNext = void 0;

var lodash_1 = __importDefault(require("lodash"));

var getNext = function getNext(tokens, index) {
  var next;

  while (lodash_1["default"].isUndefined(next)) {
    next = tokens[index + 1];
    index = index + 1;
  }

  return next;
};

exports.getNext = getNext;

var getPrev = function getPrev(tokens, index) {
  var prev;

  while (lodash_1["default"].isUndefined(prev)) {
    prev = tokens[index - 1];
    index = index - 1;
  }

  return prev;
};

exports.getPrev = getPrev;